export default __webpack_public_path__ + "static/media/History.44178c04.svg";